import { createApi } from '@reduxjs/toolkit/query/react';
import { client } from '../../../api/NestClient';
import { nestBaseQuery } from '../../../utils/nestBaseQuery';
import type { paths } from '../../../api/types/api';

/**
 * Response type for user-issues endpoint  
 * 
 */
type GetUserIssuesResponse =
  paths['/api/v1/user-issues']['get']['responses']['200']['content']['application/json'];

// export type SupportHistoryQueryParams = {
//   pageNumber?: number;
//   pageSize?: number;
//   orderBy?: string;
//   orderDirection?: string;
//   snapshot_time?: number | null;
// };

export type SupportHistoryQueryParams =
  paths['/api/v1/user-issues']['get']['parameters']['query'];


export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: nestBaseQuery,
  tagTypes: ['SupportHistory'],
  endpoints: (builder) => ({
    getSupportHistory: builder.query<GetUserIssuesResponse, SupportHistoryQueryParams>({
       queryFn: (params) => {
        const query: SupportHistoryQueryParams = {
          pageNumber: params.pageNumber ?? 1,
          pageSize: params.pageSize ?? 25,
          orderBy: (params.orderBy ?? 'enteredTimestamp') as SupportHistoryQueryParams['orderBy'],
          orderDirection: (params.orderDirection ?? 'DESC') as SupportHistoryQueryParams['orderDirection'],
        };
        if (params.snapshot_time != null) {
          query.snapshot_time = Math.floor(Number(params.snapshot_time));
        }
        return client.GET('/api/v1/user-issues', {
          params: { query },
        });
      },
      providesTags: ['SupportHistory'],
    }),
  }),
});

export const { useGetSupportHistoryQuery } = supportApi;
